import moment from "moment";

export function durationToWeeks(from: Date, to: Date, utc = true) {
  if (!from || !to) {
    return [];
  }

  const m = utc ? moment.utc : moment;

  const fromMoment = m(from).startOf("isoWeek");
  const toMoment = m(to).startOf("isoWeek");

  const result: Date[] = [];

  for (const m = fromMoment.clone(); m.isSameOrBefore(toMoment); m.add(1, "week")) {
    result.push(m.toDate());
  }

  return result;
}

export function durationToWeeksM(from: moment.Moment, to: moment.Moment) {
  if (!from || !to) {
    return [];
  }

  const result: Date[] = [];

  for (const m = from.clone(); m.isSameOrBefore(to); m.add(1, "week")) {
    result.push(m.toDate());
  }

  return result;
}

export function weeksToDurations(_weeks: Date[] = []): CustomDuration[] {
  const weeks = _weeks.map((x) => moment.utc(x).startOf("day").toDate());

  const sorted = weeks.sortBy((x) => x.getTime());

  const adjoiningWeeks: Date[][] = [];
  let prev: moment.Moment = null;
  // console.log("sorted", sorted);
  for (const week of sorted) {
    if (!prev) {
      adjoiningWeeks.push([week]);
      prev = moment.utc(week);
    }

    const w = moment.utc(week);

    if (prev.diff(w, "week", false) < -1) {
      adjoiningWeeks.push([week]);
    } else {
      adjoiningWeeks[adjoiningWeeks.length - 1].push(week);
    }

    prev = w.clone();
  }

  const result = adjoiningWeeks.map((x) => ({
    From: x[0],
    To: moment(x[x.length - 1])
      .endOf("isoWeek")
      .toDate()
  }));

  return result;
}

export function durationsToWeeks(durations: CustomDuration[], uniq = true): Date[] {
  const result = durations.selectMany((d) => durationToWeeks(d.From, d.To));
  return uniq ? result.uniqueBy((x) => x.toDateString()) : result;
}

export function durationsToWeeks1(
  durations: Array<{ from: Date; to: Date }>,
  uniq = true
): Date[] {
  const result = durations.selectMany((d) => durationToWeeks(d.from, d.to));
  return uniq ? result.uniqueBy((x) => x.toDateString()) : result;
}

export function weeksToDurations1(_weeks: Date[] = []): Array<{ from: Date; to: Date }> {
  return weeksToDurations(_weeks).map((x) => ({ from: x.From, to: x.To }));
}
